import axios from "axios";
// import jwt from "jsonwebtoken";
// import AES from "crypto-js/aes";
import { 
   credentials 
} from "../../config";
import { 
   isAuthed,
   getAuthToken
} from "../toolkit";

// initialize required configs

//set up axios instance
export const apiConnect = ( history = null) => {
   // const signXToken = jwt.sign({ time: Date.now() }, x_token, {
   //    expiresIn: "10s"
   // });
   // const encryptAES = AES.encrypt(`${Date.now()}`, app_secret_token).toString();
   let headers = {
      // "x-token": signXToken,
      // "secret-token": encryptAES,
      // gRecaptcha: captcha
   };

   if (isAuthed()) {
      headers.Authorization = `Bearer ${getAuthToken()}`;
   }

   //new instance
   const axiosInstance = axios.create({
      baseURL: credentials.app.dtpApiBaseUrl,
      // || "http://localhost:5002/api/v1/",
      headers: { ...headers }
   });

   // interceptor
   axiosInstance.interceptors.response.use(
      (response) =>
         new Promise((resolve, reject) => {
            resolve(response);
         }),
      (error) => {
         if (!error.response) {
            return new Promise((resolve, reject) => {
               reject(error);
            });
         }
         if (error.response.status === 403) {
            // localStorage.removeItem("token");
            if (history) {
               history.push("/login");
            } else {
            //    window.location = "/login" as any;
            }
         } else {
            return new Promise((resolve, reject) => {
               reject(error);
            });
         }
      }
   );
   return axiosInstance;
};